// constants.ts

export const mainURL = `https://ms-api.skylinebiz.in/api`;
// export const mainURL = `http://maharajasoaps_api.test/api`;
// export const mainURL = `https://715f-49-36-234-8.ngrok-free.app/api`;